import { Link } from 'react-router-dom';

const About = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>About Nexus IT</h1>
          <p>
            Nexus IT is a forward-looking digital infrastructure and technology solutions provider dedicated to crafting
            measurable business excellence for modern enterprises across Pakistan.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <h2>Who We Are</h2>
            <p>
              We are a registered IT &amp; Technical Services firm headquartered in Islamabad, specializing in the
              procurement, integration, and lifecycle management of mission-critical technology systems. Our solutions
              span hardware, software, and managed services, ensuring each deployment is secure, transparent, and
              cost-effective.
            </p>
            <p>
              As a supplier, system integrator, and contractor, Nexus IT handles the full breadth of service delivery
              including design, procurement, installation, commissioning, operation, and maintenance.
            </p>
          </div>
          <div style={{position: 'relative'}}>
            <img src="/Pictures/p5.jpg" alt="Nexus IT Team" style={{width: '100%', height: '350px', objectFit: 'cover', borderRadius: '5px', boxShadow: 'var(--shadow)'}} />
          </div>
        </div>
        
        <div className="container" style={{marginTop: '3rem'}}>
          <div className="badge" style={{marginBottom: '1.5rem'}}>Core Differentiators</div>
          <div className="two-column">
            <ul className="checklist">
              <li>End-to-end IT infrastructure and integration expertise</li>
              <li>Customizable solutions tailored to complex enterprise needs</li>
            </ul>
            <ul className="checklist">
              <li>Global alliances that unlock cutting-edge technologies</li>
              <li>Strong governance, quality assurance, and continuous support</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container split">
          <div className="text-block">
            <span className="tagline">Our Vision</span>
            <h2>Shaping the Future with Technology Excellence</h2>
            <p>
              To be a leading digital transformation partner that drives innovation and helps organizations unlock their
              strategic potential through intelligent, secure, and integrated technology ecosystems.
            </p>
          </div>
          <div className="text-block">
            <span className="tagline">Our Mission</span>
            <h2>Empowering Organizations for Lasting Value</h2>
            <p>
              To empower organizations with technology solutions that simplify complexity, accelerate growth, and create
              measurable value. We combine best practices, domain expertise, and localized knowledge to deliver
              high-performing IT environments.
            </p>
          </div>
        </div>
        
        <div className="container" style={{marginTop: '3rem', textAlign: 'center'}}>
          <div style={{position: 'relative', display: 'inline-block', borderRadius: '5px', overflow: 'hidden', boxShadow: 'var(--shadow)', maxWidth: '800px', margin: '0 auto'}}>
            <img src="/Pictures/p6.jpg" alt="Technology Innovation" style={{width: '100%', height: '400px', objectFit: 'cover'}} />
            <div style={{position: 'absolute', bottom: '0', left: '0', right: '0', background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)', padding: '2rem', color: 'white', textAlign: 'left'}}>
              <h3 style={{color: 'white', marginBottom: '0.5rem'}}>Innovation at Our Core</h3>
              <p style={{margin: 0, opacity: 0.9}}>Driving digital transformation through cutting-edge technology solutions and forward-thinking strategies.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container split">
          <div className="text-block">
            <span className="badge">Our Approach</span>
            <h2>Integration with Purpose</h2>
            <p>
              Every engagement is aligned with business outcomes. We collaborate closely with stakeholders to
              understand objectives, define the right technology stack, and orchestrate adoption with precision.
            </p>
            <ul className="checklist">
              <li>Consultative roadmap development</li>
              <li>Rigorous project management and governance</li>
              <li>Skill transfer and enablement for client teams</li>
              <li>Proactive support and lifecycle optimization</li>
            </ul>
          </div>
          <div className="stat-grid">
            <article className="stat-card">
              <h4>Industry Coverage</h4>
              <p>Serving government, enterprise, finance, education, and telecom sectors.</p>
            </article>
            <article className="stat-card">
              <h4>Scalable Delivery</h4>
              <p>From proof-of-concept to nationwide rollouts, we scale with your ambition.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Partner with Nexus IT</h2>
              <p>Discover how our team can help you plan, deploy, and optimize transformative IT initiatives.</p>
            </div>
            <Link className="btn btn-white" to="/contact">
              Connect With Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
